import React from 'react';
import { Link } from '../Link';

export const SubNav = () => (
  <div id="subnav" className="noprint">
    <ul>
      <li><Link href="/">Home</Link></li>
      <li><Link href="/blog">Blog</Link></li>
      <li><Link href="https://secure.actblue.com/donate/fcd-membership">Join</Link></li>
      <li><Link href="/issues">Issues</Link></li>
      <li><Link href="/endorsements">Endorsements</Link></li>
      <li><Link href="/calendar">Events</Link></li>
      <li><Link href="/volunteer">Volunteer</Link></li>
    </ul>
  </div>
);
